/* istanbul ignore file */
import React from 'react';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import AssetBreadcrumbs from 'domain/finance/assets/shared/AssetBreadcrumbs';

const SingleAssetBreadcrumbs = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useAssetUrl();
  const id = data?.getValueBySource('inventoryNumber');
  const assetNumber = data?.getValueBySource('inventoryNumber');

  return (
    <AssetBreadcrumbs>
      <SingleBreadcrumbItem entity={assetNumber || id} link={getSingleEntityUrl(id)} />
      {children}
    </AssetBreadcrumbs>
  );
};

export default SingleAssetBreadcrumbs;
